/* eslint-disable */


      export interface IntrospectionResultData {
        __schema: {
          types: {
            kind: string;
            name: string;
            possibleTypes: {
              name: string;
            }[];
          }[];
        };
      }
      const result: IntrospectionResultData = {
  "__schema": {
    "types": [
      {
        "kind": "INTERFACE",
        "name": "User",
        "possibleTypes": [
          {
            "name": "Client"
          },
          {
            "name": "Lawyer"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "Content",
        "possibleTypes": [
          {
            "name": "AudioContent"
          },
          {
            "name": "ImageContent"
          },
          {
            "name": "TextContent"
          }
        ]
      }
    ]
  }
};
      export default result;
    